import * as React from 'react'

import { requestPost } from '../../../../modules/request/index'
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

export const SUPPORT_ARTICLE_URL = 'https://support.quill.org/en/articles/16014799-how-do-i-merge-classes'

interface MergeClassesPromptModalProps {
  close: () => void;
  numberOfImportedClasses: number;
  averageStudentsPerClass: number;
}

const MergeClassesPromptModal = ({ close, numberOfImportedClasses, averageStudentsPerClass, }: MergeClassesPromptModalProps) => {
  const handleDismiss = () => {
    requestPost('/milestones/complete_dismiss_merge_classes_prompt')
    close()
  }

  const { modalRef, } = useModalAccessibility(handleDismiss)

  return (
    <div className="modal-container merge-classes-prompt-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="mergeClassesPromptModalTitle"
        aria-modal="true"
        className="merge-classes-prompt-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="title-row">
          <h3 className="title" id="mergeClassesPromptModalTitle">You may want to merge your classes</h3>
        </div>
        <div className="merge-classes-prompt-modal-text">
          <p>We noticed you have {numberOfImportedClasses} classes, with an average of {averageStudentsPerClass} rostered students per class. Quill supports this number of classes, but merging some of your classes may improve usability.</p>
          <p>You can merge any classes using the <strong>Merge classes</strong> action for a class.</p>
        </div>
        <div className="form-buttons space-between">
          <a className="focus-on-light" href={SUPPORT_ARTICLE_URL} onClick={handleDismiss} rel="noopener noreferrer" target="_blank">Learn more here</a>
          <button className="quill-button contained green medium focus-on-light" onClick={handleDismiss} type="button">Close</button>
        </div>
      </div>
    </div>
  )
}

export default MergeClassesPromptModal
